import classNames from "classnames";
import {FiArrowRight} from "react-icons/fi";
import {Link} from "react-router";

import Button from "@/components/button/Button";
import {Icon} from "@/components/icon/Icon.tsx";
import {PublicProfile} from "@/lib/types/isitdown.ts";

import {SimilarServiceCard} from "./SimilarServiceCard.tsx";

import styles from "./SimilarServices.module.scss";

interface SimilarServicesProps {
  similarServices: PublicProfile[];
}

export const SimilarServices = ({similarServices}: SimilarServicesProps) => {
  if (similarServices.length === 0) {
    return null;
  }

  return (
    <div className={classNames(styles.container, "d-flex flex-column align-items-center")}>
      <div className={styles.header}>
        <h2 className="marketingTextS3Bold pulse-color-white">Similar Services</h2>
        <Button variant="linkGreen" typography="linkBold" as={Link} to="/status" className={styles.viewAllButton}>
          View All Services <Icon icon={FiArrowRight} />
        </Button>
      </div>
      <div className={styles.servicesList}>
        {similarServices.map((service: PublicProfile) => (
          <SimilarServiceCard key={`similar-service-${service.id}`} service={service} />
        ))}
      </div>
    </div>
  );
};
